import { FC } from "react"
import { useLocation } from "react-router-dom"
import { useFetchActivitiesByBrandQuery } from "../../../../redux/queries"
import { Brand } from "../../../../types"
import ActivityTable from "../../activity/table"

interface Props {
  brand: Brand
}

const BrandActivities: FC<Props> = ({ brand }) => {
  const location = useLocation()

  const {
    data: activities = [],
    isFetching,
    refetch
  } = useFetchActivitiesByBrandQuery(
    { brand_id: brand?.id, limit: 50 },
    { skip: !brand?.id }
  )

  // Build returnUrl to preserve brand context
  const returnUrl = encodeURIComponent(location.pathname + location.search)

  return (
    <div className="px-6">
      <ActivityTable
        data={activities}
        isLoading={isFetching}
        isBrandActivity
        refetch={refetch}
        returnUrl={returnUrl}
        brandName={brand?.name}
      />
    </div>
  )
}

export default BrandActivities
